.stack {
  width: 100%;
}

.stack section + section {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid var(--gray-300);
}
